import { render, staticRenderFns } from "./categoryDeposit.vue?vue&type=template&id=6a7fa7bb&scoped=true&"
import script from "./categoryDeposit.vue?vue&type=script&lang=js&"
export * from "./categoryDeposit.vue?vue&type=script&lang=js&"
import style0 from "./categoryDeposit.vue?vue&type=style&index=0&id=6a7fa7bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fa7bb",
  null
  
)

export default component.exports